import { z } from 'zod/mini'

const optionalString = z.optional(z.string())

const DataBridgeCommon = z.object({
  text: optionalString,
  'data-testid': optionalString,
  className: optionalString,
  disabled: z.optional(z.boolean()),
  onError: z.optional(
    z.function({
      input: [z.string()]
    })
  )
})

export const FileMeta = z.object({
  name: z.string(),
  size: z.number(),
  type: z.enum(['csv', 'excel', 'json', ''])
})

export const FileData = z.object({
  sheetName: z.string(),
  records: z.array(z.record(z.string(), z.unknown()))
})

export const DataBridgeImportProps = z.extend(DataBridgeCommon, {
  disabled: z.optional(z.boolean()),
  onImport: z.function({
    input: [FileMeta, z.array(FileData), z.array(z.string())]
  })
})

export const DataBridgeExportProps = z.extend(DataBridgeCommon, {
  disabled: z.optional(z.boolean()),
  filename: optionalString,
  getRecords: z.function({
    output: z.array(z.record(z.string(), z.unknown()))
  }),
  onExport: z.function({
    input: [z.string(), z.string()]
  })
})

export const DataBridgeProps = z.object({
  disabled: z.optional(z.boolean()),
  disabledImport: z.optional(z.boolean()),
  disabledExport: z.optional(z.boolean()),
  filename: optionalString,
  getRecords: DataBridgeExportProps.shape.getRecords,
  onImport: z.function({
    input: [FileData.shape.records, FileMeta],
    output: z.any()
  }),
  /** インポート失敗時（ファイル形式エラー等）に親に通知。引数はエラーメッセージ。空文字でクリア。 */
  onImportError: z.optional(z.function({ input: [z.string()] }))
})

export const DataBridgePageState = z.object({
  fileMeta: FileMeta,
  selectedSheetIndex: z.union([z.number(), z.null()]),
  sheetList: z.array(z.string()),
  errors: z.array(z.string())
})
/** @typedef {import('zod').infer<DataBridgePageState>} _DataBridgePageState */
